'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _prepareFetch2 = require('./prepareFetch');

var _prepareFetch3 = _interopRequireDefault(_prepareFetch2);

var _isDefined = require('../validators/isDefined');

var _isDefined2 = _interopRequireDefault(_isDefined);

var _isFunction = require('../validators/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var call = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(data) {
    var _prepareFetch, url, options, responder, response;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _prepareFetch = (0, _prepareFetch3.default)(data), url = _prepareFetch.url, options = _prepareFetch.options, responder = _prepareFetch.responder;
            _context.next = 3;
            return fetch(url, options);

          case 3:
            response = _context.sent;

            if (!((0, _isDefined2.default)(responder) && (0, _isFunction2.default)(responder))) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return responder(response);

          case 7:
            return _context.abrupt('return', _context.sent);

          case 8:
            return _context.abrupt('return', response);

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function call(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.default = call;